const TENANT_ID: string = import.meta.env.VITE_TENANT_ID || 'root';
const API_URL: string = import.meta.env.VITE_API_URL;
const APP_URL: string = import.meta.env.VITE_APP_URL;
const NODE_ENV: string = import.meta.env.MODE || 'development';

export const config = {
  tenantId: TENANT_ID,
  apiUrl: API_URL,
  appUrl: APP_URL,
  isDev: NODE_ENV === 'development',
  isProd: NODE_ENV === 'production',
  environment: NODE_ENV
};
